const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Real-World Scenarios',
    description:
      'Practice with simulated environments that mirror actual attack and defense scenarios used by security professionals worldwide.',
    color: 'from-[#00D9FF] to-[#0066CC]',
  },
  {
    icon: 'ri-terminal-box-line',
    title: 'Hands-On Practice',
    description:
      'No theory overload — dive straight into interactive labs, CTF challenges, and live sandboxes that build real muscle memory.',
    color: 'from-[#00C896] to-[#007A5E]',
  },
  {
    icon: 'ri-group-line',
    title: 'Expert Community',
    description:
      'Connect with 50,000+ security professionals, share write-ups, ask questions, and get mentored by industry veterans.',
    color: 'from-[#FF6B35] to-[#CC4400]',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Track Your Progress',
    description:
      'Visual skill trees and achievement badges keep you motivated and show exactly where you stand on your learning journey.',
    color: 'from-[#A855F7] to-[#6B21A8]',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Curated Resources',
    description:
      'Access a library of cheat sheets, video tutorials, and documentation curated by certified security experts.',
    color: 'from-[#F59E0B] to-[#B45309]',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Certifications & Badges',
    description:
      'Earn verifiable digital badges and certificates recognized by top employers in the cybersecurity industry.',
    color: 'from-[#EC4899] to-[#9D174D]',
  },
];

const OverviewSection = () => (
  <section id="overview" className="py-24 bg-[#F7F9FC]">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      {/* Header */}
      <div className="text-center mb-16">
        <span className="inline-block text-[#00D9FF] text-xs font-bold tracking-widest uppercase mb-3">
          Why CyberSkill Hub
        </span>
        <h2 className="text-4xl md:text-5xl font-black text-[#0A1628] mb-4">
          Everything You Need to
          <br />
          <span className="text-[#00D9FF]">Level Up Your Skills</span>
        </h2>
        <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
          A complete ecosystem for cybersecurity learners — from absolute beginners to seasoned professionals looking to sharpen their edge.
        </p>
      </div>

      {/* Feature Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((f) => (
          <div
            key={f.title}
            className="bg-white rounded-2xl p-7 border border-gray-100 hover:-translate-y-1 transition-transform duration-300 cursor-pointer group"
          >
            <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${f.color} flex items-center justify-center mb-5`}>
              <i className={`${f.icon} text-white text-2xl`}></i>
            </div>
            <h3 className="text-[#0A1628] font-bold text-lg mb-2">{f.title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{f.description}</p>
            <div className="mt-5 flex items-center gap-1 text-[#00D9FF] text-sm font-semibold group-hover:gap-2 transition-all duration-200">
              Learn More <i className="ri-arrow-right-line"></i>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Banner */}
      <div className="mt-16 rounded-2xl bg-gradient-to-r from-[#0A1628] to-[#0F2A4A] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h3 className="text-white text-2xl md:text-3xl font-black mb-2">
            Start your journey today — it&apos;s free.
          </h3>
          <p className="text-gray-400 text-sm">No credit card required. Access 50+ labs instantly.</p>
        </div>
        <a
          href="#highlighted-labs"
          className="px-8 py-4 rounded-full bg-[#00D9FF] text-[#0A1628] font-bold text-sm hover:bg-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          Explore Free Labs
        </a>
      </div>
    </div>
  </section>
);

export default OverviewSection;
